import { ErrorMessage as RHFErrorMessage } from '@hookform/error-message';

const ErrorMessage = ({ name, errors, ...rest }) => {
  return <RHFErrorMessage name={name} errors={errors} as="p" className="mt-1 text-sm text-red-500" {...rest} />;
};

export default ErrorMessage;
